import { useOffersTotal } from '@hooks';
import React from 'react';
import * as S from '@modules/Dashboard/Home/modules/HomeProducts/styled';
import { BaseContent, Button, Heading, useMediaQueryContext, useModalContext, useSlider, } from '@fourthwall/components';
import { CreateProductModal } from '@modules/Dashboard/Products';
import { useHomeProducts } from '@modules/Dashboard/Home/modules/HomeProducts/useHomeProducts';
import { routing } from '@utils/routing';
import { getProductHref } from '@modules/Dashboard/Home/modules/HomeProducts/components/HomeProductsSlider/utils';
import { ProductColorVariantProvider } from '@fourthwall/module-product';
import { HomeProductsProductBox } from '@modules/Dashboard/Home/modules/HomeProducts/components/HomeProductsProductBox';
const getCopyProps = (count) => {
    // no products
    if (count === 0) {
        return {
            title: 'Create your first product',
            subtitle: 'Design a new product or list something you own.',
        };
    }
    // 1 to 4 products created
    if (count <= 4) {
        return {
            title: 'Create another product',
            subtitle: 'We recommend giving supporters 3-5 options to choose from.',
        };
    }
    // > 4 products created
    return {
        title: 'Create another product',
        subtitle: 'Give supporters more options to choose from.',
    };
};
export const HomeProductsContainer = () => {
    const offersTotal = useOffersTotal();
    const mediaQuery = useMediaQueryContext();
    const { open } = useModalContext();
    const homeProducts = useHomeProducts();
    const slider = useSlider();
    if (!offersTotal)
        return null;
    const count = offersTotal.all;
    return (React.createElement(S.Container, null,
        React.createElement(S.Header, null,
            React.createElement("div", null, mediaQuery.tablet ? (React.createElement(Heading, { type: "h7", weight: "semibold" }, getCopyProps(count).title)) : (React.createElement(BaseContent, null,
                React.createElement("strong", null,
                    " ",
                    getCopyProps(count).title)))),
            !homeProducts?.categories.visible && (React.createElement(S.ButtonGroup, null,
                React.createElement(Button, { label: "Browse all products", appearance: "secondary", size: "xsmall", fullWidth: true, href: routing.productCatalog.self, analytics: "browseAllProducts" }),
                React.createElement(Button, { label: "Create product", appearance: "primary", size: "xsmall", fullWidth: true, onClick: () => open(CreateProductModal), analytics: "createANewProduct" })))),
        React.createElement("div", null, homeProducts?.categories && (React.createElement("div", { ...slider.getContainerProps() },
            React.createElement(S.SliderHeader, null,
                homeProducts.categories && homeProducts.categories.visible && mediaQuery.tablet && (React.createElement(S.PillContainer, null, homeProducts.categories.options.map((option) => {
                    return (React.createElement(S.PillItem, { key: option.value, active: option.value === homeProducts.categories.value, onClick: () => homeProducts?.categories.onChange(option.value) }, option.label));
                }))),
                homeProducts.categories.visible && (React.createElement(S.ButtonGroup, null,
                    React.createElement(Button, { label: "Browse all products", appearance: "secondary", size: "xsmall", fullWidth: true, href: routing.productCatalog.self, analytics: "browseAllProducts" }),
                    React.createElement(Button, { label: "Create product", appearance: "primary", size: "xsmall", fullWidth: true, onClick: () => open(CreateProductModal), analytics: "createANewProduct" })))),
            React.createElement(Slider, { products: homeProducts.products, slider: slider, onProductClick: homeProducts.onProductClick }))))));
};
const Slider = ({ products, slider, onProductClick, }) => {
    if (!products.length) {
        return (React.createElement(S.EmptyState, null,
            React.createElement(BaseContent, null,
                React.createElement("p", null, "You don\u2019t have any favorite products added yet"),
                React.createElement("p", null,
                    React.createElement("a", { href: routing.productCatalog.self, target: "_blank", rel: "noreferrer" }, "Browse product catalog")))));
    }
    return (React.createElement(S.Slider, { ...slider.getSliderProps() }, products.map((product) => {
        const href = getProductHref(product.slug);
        return (React.createElement(S.Slide, { key: product.id, href: href, target: "_blank", onClick: () => onProductClick(product), "data-analytics": "viewProduct", ...slider.getSlideProps() },
            React.createElement(ProductColorVariantProvider, { colorVariants: product.variants.matched },
                React.createElement(HomeProductsProductBox, { product: product, href: href }))));
    })));
};
